import { render, staticRenderFns } from "./NodeDetail.vue?vue&type=template&id=26ca510f&scoped=true&"
import script from "./NodeDetail.vue?vue&type=script&lang=js&"
export * from "./NodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./NodeDetail.vue?vue&type=style&index=0&id=26ca510f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ca510f",
  null
  
)

export default component.exports